"use strict"

import React, {useState} from "react"
import {observer} from "mobx-react"
import ReCAPTCHA from "react-google-recaptcha"
import MobxReactForm from "mobx-react-form"
import config from "../../global/config/settings"
import validatorjs from "validatorjs"
import dvr from "mobx-react-form/lib/validators/DVR"
import {injectIntl} from "react-intl"
import {Container, Grid, Typography, Link, Box} from "@material-ui/core"

import XsInput from "../../global/ui/xsInput/xsInput"
import XsNumberInput from "../../global/ui/xsInput/xsNumberInput"
import XsButton from "../../global/ui/xsButton/xsButton"
// import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"

import LoginStore from "./loginStore"
import GlobalStore from "../../global/store/GlobalStore"
import {isEmailValid} from "../../global/helpers/functions"
import XsPublicHeader from "../../global/ui/xsHeader/xsPublicHeader"
import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"

function Register() {
	const hooks = {
		onSubmit(form) {
			const {email, company_name, company_identifier} = form.values()

			if (isEmpty(email) || isEmpty(company_name) || isEmpty(company_identifier) || !isEmailValid(email)) {
				GlobalStore.setNotificationMessage("Vyplnte všetky polia!", "", "warning")
				form.invalidate()
			}
		},
		onSuccess(form) {
			LoginStore.hanldeRegistration(form)
		},
		onError() {}
	}

	const [form] = useState(
		new MobxReactForm(
			{
				fields: {
					email: {label: "Prihlasovacie meno / email", rules: "required"},
					company_name: {label: "Obchodné meno / žiadateľ", rules: "required"},
					company_identifier: {label: "IČO", rules: "required|between:8,8"},
					personal_data: {
						label: "Beriem na vedomie spracúvanie poskytnutých osobných údajov",
						rules: "",
						type: "checkbox",
						value: true
					}
				}
			},
			{plugins: {dvr: dvr(validatorjs)}, hooks}
		)
	)

	return (
		<React.Fragment>
			<XsPublicHeader />
			<Container maxWidth="lg" style={{marginTop: 96}}>
				<Grid container justify="center">
					<Grid item xs={12} md={7}>
						<Grid container direction="column" justify="center">
							<Grid container direction="column" spacing={3}>
								<Grid item className="textCenter">
									<Typography variant="h3">Registrácia žiadateľa</Typography>
								</Grid>
								<Grid item>
									<Box p={2}>
										<Grid item container direction="column" spacing={1}>
											<Grid item container spacing={4}>
												<Grid item xs={12} md={7}>
													<XsInput
														field={form.$("company_name")}
														autoFocus={true}
														submitAction={(e) => form.onSubmit(e)}
													/>
												</Grid>
												<Grid item xs={12} md={5} data-tip data-for="company_identifier">
													<XsNumberInput field={form.$("company_identifier")} step={"1"} min={"1"} />
												</Grid>
												<Grid item xs={12} md={7}>
													<XsInput
														field={form.$("email")}
														submitAction={(e) => form.onSubmit(e)}
														regex={(val) => isEmailValid(val)}
													/>
												</Grid>
											</Grid>
											<Grid item container spacing={1} className="mt-3">
												<Grid item>
													<Typography variant="body1">Spracúvanie osobných údajov:</Typography>
												</Grid>
												<Grid item>
													<Link
														variant="body1"
														className="pointer"
														underline="always"
														onClick={() => window.open("https://www.siea.sk/o-siea/ochrana-osobnych-udajov/", "_blank")}
													>
														https://www.siea.sk/o-siea/ochrana-osobnych-udajov/
													</Link>
												</Grid>
											</Grid>
											<Grid item>
												<XsCheckbox field={form.$("personal_data")} />
											</Grid>
											{GlobalStore.enabledRecaptchaV2 && (
												<Grid item>
													<ReCAPTCHA
														sitekey={config.SITE_KEY_V2 || ""}
														onChange={(token) => {
															GlobalStore.tokenRecaptchaV2 = token
														}}
													/>
												</Grid>
											)}
											<Grid item container justify="flex-end">
												<Grid item>
													<XsButton
														disabled={GlobalStore.isRegistrationClose()}
														text="Registrovať sa"
														fullWidth={false}
														onClick={form.onSubmit}
													/>
												</Grid>
											</Grid>
										</Grid>
									</Box>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</React.Fragment>
	)
}

export default injectIntl(observer(Register))

